/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const ClassSignupAvailabilityStatus = {
  Available: "AVAILABLE",
  PaidAvailable: "PAID_AVAILABLE",
  WaitlistAvailable: "WAITLIST_AVAILABLE",
  FutureUnavailable: "FUTURE_UNAVAILABLE",
  StartedUnavailable: "STARTED_UNAVAILABLE",
  NoSignupUnavailable: "NO_SIGNUP_UNAVAILABLE",
  Unavailable: "UNAVAILABLE",
} as const;

export type ClassSignupAvailabilityStatus =
  (typeof ClassSignupAvailabilityStatus)[keyof typeof ClassSignupAvailabilityStatus];

export type ClassSignupAvailabilityStatusEnumType =
  typeof ClassSignupAvailabilityStatus;
export type ClassSignupAvailabilityStatusOptional =
  ClassSignupAvailabilityStatus;
export type ClassSignupAvailabilityStatusTrackedI =
  ClassSignupAvailabilityStatus;
export type ClassSignupAvailabilityStatusTracked =
  ClassSignupAvailabilityStatus;
export type ClassSignupAvailabilityStatusMetaI = EnumMetaType<
  ClassSignupAvailabilityStatusEnumType,
  ClassSignupAvailabilityStatus
>;
export const ClassSignupAvailabilityStatusMeta = typeMetaEnum<
  ClassSignupAvailabilityStatusEnumType,
  ClassSignupAvailabilityStatus
>("ClassSignupAvailabilityStatus", ClassSignupAvailabilityStatus);
export function transformDatesClassSignupAvailabilityStatus(
  model: ClassSignupAvailabilityStatus,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
